import { render } from "./QuextButton.vue?vue&type=template&id=2a0168b9"
import script from "./QuextButton.vue?vue&type=script&lang=js"
export * from "./QuextButton.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__